import Repository from './Repository.js';

class DebugRepository extends Repository {
    async getAccounts(query) {
        return await this.get('debug/accounts', query);
    }

    async createSession(body) {
        return await this.post('debug/accounts', body);
    }
}

export default new DebugRepository();
